"use client";
import CircleLoader from "@/app/common/CircleLoader";

export default function Loading() {
  return <CircleLoader />;
}
